import _ from 'lodash'
import angular from 'angular'
export default ['$q', dataUILinker]

/* Checkout PublishActions Controller to see how to use this service. */
function dataUILinker($q) {
  this.procComponentState = function procComponentState(vm) {
    const mutatorMap = {}
    for (let [key, value] of Object.entries(vm)) {
      if (angular.isUndefined(value) || value === null) {
        continue
      }
      if (value.constructor !== {}.constructor) {
        continue
      }
      if (!Object.prototype.hasOwnProperty.call(value, 'mutators')) {
        continue
      }
      mutatorMap[key] = {
        deps: [],
        funcs: [],
        priority: 0,
        _resolved: [],
        state: value,
      }
      mutatorMap[key]['defer'] = $q.defer()
      mutatorMap[key]['datum'] = mutatorMap[key]['defer'].promise
      mutatorMap[key]['handlers'] = Object.assign({}, value['handlers'])
      for (let mdx = 0; mdx < value['mutators'].length; mdx++) {
        let mutator = value['mutators'][mdx]
        if (typeof mutator === 'string') {
          mutatorMap[key]['deps'].push(mutator)
          continue
        } else if (typeof mutator === 'function') {
          mutatorMap[key]['funcs'].push(mutator)
          continue
        } else {
          console.error(`Invalid mutator for vm.${key}`)
        }
      }
      mutatorMap[key]['priority'] = mutatorMap[key]['deps'].length
    }
    // const unorderedMutators = Object.entries(mutatorMap)
    // const sortedMutators = []
    const groupedNodes = _.keyBy(
      _.sortBy(
        Object.entries(
          _.groupBy(Object.entries(mutatorMap), function(o) {
            if (o[1]['deps'].length > 0) return 'minion'
            return 'root'
          })
        ),
        function(o) {
          return o[0]
        }
      ), // sortBy
      function(o) {
        return o[0]
      }
    ) // keyBy
    for (let [rKey, rValue] of groupedNodes['root'][1]) {
      let minions = groupedNodes['minion'][1].slice()
      while (minions.length > 0) {
        let [minionName, minionValue] = minions.shift()
        if (minionValue['deps'].indexOf(rKey) > -1) {
          minionValue['_resolved'][rKey] = rValue['datum']
        }
        for (let [mKey, mValue] of minions) {
          if (mValue['deps'].indexOf(minionName) > -1) {
            if (minionValue['deps'].indexOf(mKey) > -1) {
              throw Error(`Circular dependency found: ${minionName}:${mKey}`)
            }
            mValue['priority'] =
              mValue['priority'] + minionValue['priority'] + 1
            // console.log('a', mValue['priority'], mValue['deps'])
            mValue['_resolved'][minionName] = minionValue['datum']
          } else if (minionValue['deps'].indexOf(mKey) > -1) {
            minionValue['priority'] =
              minionValue['priority'] + mValue['priority'] + 1
            // console.log('b', minionValue['priority'], minionValue['deps'])
            minionValue['_resolved'][mKey] = mValue['datum']
          }
        }
      }
    }
    for (let [, node] of Object.entries(
      _.sortBy(Object.values(mutatorMap), function(o) {
        return o['priority'] * -1
      })
    )) {
      for (let fdx = 0; fdx < node['funcs'].length; fdx++) {
        let funcArgs = node['deps'].reduce(
          function reduceDeps(acc, dependency) {
            acc.push(mutatorMap[dependency]['datum'])
            return acc
          },
          [node['state'], node['defer']]
        )
        node['funcs'][fdx].apply(null, funcArgs)
      }
      for (let [hName] of Object.entries(node['state']['handlers'])) {
        let stateHandler = node['state']['handlers'][hName]
        node['state']['handlers'][hName] = function proxyHandler() {
          let handlerArgs = [node['state'], node['defer']]
          for (let adx = 0; adx < arguments.length; adx++) {
            handlerArgs.push(arguments[adx])
          }
          stateHandler.apply(null, handlerArgs)
        }
      }
    }
  }
}
